<template>
  <div>
    <div class="tiles">
      <TileItem v-for="product in this.pagedTableData"
                v-bind:key="product.id"
                :product="product"></TileItem>
    </div>

    <el-pagination layout="prev, pager, next"
                   :total="this.filteredTableData.length"
                   @current-change="setPage">
    </el-pagination>
  </div>
</template>

<script>
  import TileItem from './TileItem/TileItem.vue';
  import { basicUtils } from '../../utils/utils';

  export default {
    components: {
      TileItem,
    },
    props: {
      products: {},
      filters: {
        supplier: null,
      },
    },
    data() {
      return {
        page: 1,
        pageSize: 12,
      };
    },
    computed: {
      cart() {
        return this.$store.getters['cart/cart'];
      },
      pagedTableData() {
        return this
          .filteredTableData
          .slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
      },
      filteredTableData() {
        if (this.filters.autocomplete !== '') {
          return this.products.filter((item) => item.name.toLowerCase()
            .indexOf(this.filters.autocomplete.toLowerCase()) > -1);
        }
        if (this.filters.supplier !== null) {
          return basicUtils.filter(this.products, 'supplier', this.filters.supplier);
        }

        if (this.filters.tag !== null) {
          return basicUtils.filter(this.products, 'tag', this.filters.tag);
        }
        return this.products;
      },
    },
    methods: {
      setPage(val) {
        this.page = val;
      },
    },
  };
</script>

<style lang="stylus">
  @import '~@/assets/css/main.styl';

  .tiles {
    display flex;
    flex-wrap: wrap
    flex-direction row
    justify-content space-between;
    width: 95%;
  }

</style>
